import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.4 1.075c-.4-.195-.8-.098-1.1.196 0 0-.9.684-3.3.684-1.3 0-2.4-.489-3.6-.88C8.1.489 6.7 0 5 0 1.8 0 .5 1.075.3 1.27s-.3.392-.3.685v18.574c0 .587.4.978 1 .978s1-.391 1-.978v-6.354c.4-.196 1.4-.489 3-.489 1.3 0 2.4.489 3.6.88 1.3.489 2.7 1.075 4.4 1.075 3.2 0 4.5-1.075 4.7-1.27s.3-.392.3-.685V1.955q0-.586-.6-.88M16 13.197c-.4.196-1.4.489-3 .489-1.3 0-2.4-.489-3.6-.88-1.3-.586-2.7-1.075-4.4-1.075-1.3 0-2.3.195-3 .39V2.445c.4-.196 1.4-.489 3-.489 1.3 0 2.4.489 3.6.88 1.3.586 2.7 1.075 4.4 1.075 1.3 0 2.3-.195 3-.391v9.678z"
    }, null, -1)
  ]))]))
}
export default { render: render }